export default (function (_ref) {
  var request = _ref.request;
  return {
    ledAdd: function ledAdd(data) {
      return request({
        url: '/iot/led/add',
        method: 'post',
        data: data
      });
    },
    ledModify: function ledModify(data) {
      return request({
        url: "/iot/led/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    ledDel: function ledDel(id) {
      return request({
        url: "/iot/led/".concat(id, "/del"),
        method: 'delete'
      });
    },
    ledQuery: function ledQuery(data) {
      return request({
        url: '/iot/led/query',
        method: 'get',
        params: data
      });
    },
    ledDetail: function ledDetail(id) {
      return request({
        url: "/iot/led/".concat(id, "/detail"),
        method: 'get'
      });
    },
    ledDebug: function ledDebug(handleId, data) {
      return request({
        url: "/iot/led/".concat(handleId, "/debug"),
        method: 'POST',
        params: data
      });
    },
    ledSimulate: function ledSimulate(handleId) {
      return request({
        url: "/iot/led/".concat(handleId, "/simulate"),
        method: 'POST'
      });
    }
  };
});